import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";
import axios from 'axios';

const excelExportApi = axios.create({
  baseURL: 'https://api-mx.ethicsglobal.com',
  timeout: 600000, // 10 minutos
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});


// Interceptor para manejar errores
excelExportApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED') {
      console.error('La solicitud de exportación de Excel ha excedido el tiempo de espera');
      // Aquí puedes manejar el error, por ejemplo, mostrando un mensaje al usuario
    } else if (error.response) {
      console.error('Error en la respuesta del servidor:', error.response.status);
    } else if (error.request) {
      console.error('No se recibió respuesta del servidor');
    } else {
      console.error('Error al configurar la solicitud:', error.message);
    }
    return Promise.reject(error);
  }
);



export const excelExportApiCall = async (method, url, data = null, config = {}) => {
  try {
    const response = await excelExportApi[method](url, data, config);
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};


const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

// Exports
export const listExports = async (propsForUpdate) => {
  const session = getSession();
  const tenant = getTenant();
  
  if (!session) return;
  
  const params = {};

  const { selectedSection, page, pageSize, lastDays } = propsForUpdate

  
  if (['all', 'report', 'involved', 'investigation', 'servicenow'].includes(selectedSection)) {
    params.kind = selectedSection;
  } else {
    showErrorMessage(getErrorMessage({ response: { status: 400 } }, "exports"));
  }

  if (lastDays) {
    params.last_days = lastDays;
  }

  if (pageSize) {
    params.page_size = pageSize;
  }

  if (page) {
    params.page = page;
  }

  try {
    const resp = await apiCall.get(`${tenant}/api/export/list/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
      params
    });
    return resp.data;
  } catch (error) {
    console.warn('files not found');
    return { data: [], message: 'files not found', meta: null };
  }
};



export const createExcelExport = async (data, lg, kind) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;

  let endPoint = '';

  const params = lg ? { lg } : {};

  if (kind === 'report') {
    endPoint = 'api/export/excel';

    try {
      const resp = await excelExportApiCall('post', `${tenant}/${endPoint}/`, data, {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
        params,
      });
      return resp;
    } catch (error) {
      showErrorMessage(getErrorMessage(error, "exports"));
      console.error(error);
    }

  } else if (kind === 'involved') {
    endPoint = 'api/export-involved/excel';

    try { 
      const resp = await apiCall.post(
        `${tenant}/${endPoint}/`,
        data,
        {
          headers: {
            IdToken: session.IdToken,
            Authorization: `Bearer ${session.AccessToken}`,
          },
        }
      );
      return resp.data;
    } catch (error) {
      console.warn('files not found');
      return { data: [], message: 'files not found', meta: null };
    }

    

  } else if (kind === 'servicenow') {
    // Plantilla "Investigation Case Import" de Citi. Solo tenants de Banamex:
    // el backend responde 403 a los demas.
    //
    // Usa apiCall y no excelExportApiCall: ese ultimo apunta a un baseURL fijo
    // (test.ethicsglobal.com), donde el token de la sesion no existe y el auth
    // responde "Login failed 3".
    endPoint = 'api/export/service-now';

    try {
      const resp = await apiCall.post(
        `${tenant}/${endPoint}/`,
        data,
        {
          headers: {
            IdToken: session.IdToken,
            Authorization: `Bearer ${session.AccessToken}`,
          },
        }
      );
      return resp.data;
    } catch (error) {
      showErrorMessage(getErrorMessage(error, "exports"));
      console.error(error);
    }

  } else if (kind === 'investigation') {
    endPoint = 'api/export-investigation/excel';
  }

  

  
};

export const downloadFile = async (alias) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;

  try {
    const resp = await apiCall.get(`${tenant}/api/export/${alias}/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "exports"));
    console.error(error);
  }
};

export const deleteFile = async (alias) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;

  try {
    const resp = await apiCall.delete(`${tenant}/api/export/delete/${alias}/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "exports"));
    console.error(error);
  }
};

// Report Templates

export const utilitiesReportTemplates = async (formId) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report-templates/utilities/${formId}/`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "exports"));
    console.error(error);
  }
};

export const listReportTemplates = async () => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/report-templates/list/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "exports"));
    console.error(error);
  }
};

export const createReportTemplate = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report-templates/create/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "exports"));
    console.error(error);
  }
};

export const retrieveReportTemplate = async (reportTemplateAlias) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report-templates/retrieve/${reportTemplateAlias}/`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "exports"));
    console.error(error);
  }
};

// Hacer una peticion para obtener el reporte en pdf
export const downloadPDFReport = async (reportId, data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/pdf/${reportId}/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
        responseType: "blob",
      }
    );
    return resp;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "exports"));
    console.error(error);
  }
};
